import type { Language } from "./texts.ts";

export type EventPageUiTexts = {
  dateAndTime: string;
  location: string;
  city: string;
  openInGoogleMaps: string;
  price: string;
  lineup: string;
  links: string;
  coupon: string;
  getTickets: string;
  chatWithAgentFomo: string;
  browseEvents: string;
  browseAllEvents: string;
  privacyPolicy: string;
  termsAndConditions: string;
  accessibility: string;
  wheelchairAccessible: string;
  eventNotFound: string;
  eventNotFoundHint: string;
  donationBased: string;
  freeEntrance: string;
  priceNotSpecified: string;
  locationNotSpecified: string;
  addToCalendar: string;
  soldOut: string;
  source: string;
  originalTextLabel: string;
  saveToMyEvents: string;
  savedToMyEvents: string;
  notifyFriends: string;
  friendsNotified: string;
  passEvent: string;
  passedEvent: string;
  tastePrompt: string;
  signInToSave: string;
  matchScore: string;
};

const englishEventPageUiTexts: EventPageUiTexts = {
  dateAndTime: "Date & Time",
  location: "Location",
  city: "City",
  openInGoogleMaps: "Open in Google Maps",
  price: "Price",
  lineup: "Lineup",
  links: "Links",
  coupon: "Coupon",
  getTickets: "Get Tickets",
  chatWithAgentFomo: "Chat with Agent FOMO",
  browseEvents: "Browse Events",
  browseAllEvents: "Browse All Events",
  privacyPolicy: "Privacy Policy",
  termsAndConditions: "Terms & Conditions",
  accessibility: "Accessibility",
  wheelchairAccessible: "Wheelchair Accessible",
  eventNotFound: "Event not found",
  eventNotFoundHint: "It may have been removed, or the link is incorrect.",
  donationBased: "Donation Based",
  freeEntrance: "Free Entrance",
  priceNotSpecified: "Price not specified",
  locationNotSpecified: "Location not specified",
  addToCalendar: "Add to Calendar",
  soldOut: "Sold Out",
  source: "Source",
  originalTextLabel: "Original post",
  saveToMyEvents: "Interested",
  savedToMyEvents: "Interested",
  notifyFriends: "Notify Friends",
  friendsNotified: "Friends Notified",
  passEvent: "Not for Me",
  passedEvent: "Passed",
  tastePrompt: "Train your taste",
  signInToSave: "Sign in to save events",
  matchScore: "Match",
};

const hebrewEventPageUiTexts: EventPageUiTexts = {
  dateAndTime: "תאריך ושעה",
  location: "מקום",
  city: "עיר",
  openInGoogleMaps: "פתיחה ב-Google Maps",
  price: "מחיר",
  lineup: "ליין אפ",
  links: "קישורים",
  coupon: "קופון",
  getTickets: "לכרטיסים",
  chatWithAgentFomo: "שיחה עם Agent FOMO",
  browseEvents: "עוד אירועים",
  browseAllEvents: "כל האירועים",
  privacyPolicy: "מדיניות פרטיות",
  termsAndConditions: "תנאי שימוש",
  accessibility: "נגישות",
  wheelchairAccessible: "נגיש לכיסא גלגלים",
  eventNotFound: "האירוע לא נמצא",
  eventNotFoundHint: "ייתכן שהוא הוסר, או שהקישור שגוי.",
  donationBased: "כובע",
  freeEntrance: "כניסה חינם",
  priceNotSpecified: "מחיר לא צוין",
  locationNotSpecified: "מקום לא צוין",
  addToCalendar: "הוספה ליומן",
  soldOut: "סולד אאוט",
  source: "מקור",
  originalTextLabel: "ניסוח מקורי",
  saveToMyEvents: "מעוניין",
  savedToMyEvents: "מעוניין",
  notifyFriends: "עדכן חברים",
  friendsNotified: "החברים עודכנו",
  passEvent: "לא בשבילי",
  passedEvent: "דלגת",
  tastePrompt: "אימון הטעם שלך",
  signInToSave: "התחבר כדי לשמור אירועים",
  matchScore: "התאמה",
};

export const eventPageUiTexts: Record<Language, EventPageUiTexts> = {
  en: englishEventPageUiTexts,
  he: hebrewEventPageUiTexts,
};

export const isRtlLanguage = (_language?: Language) => false;

export const languageFromAcceptLanguage = (_header?: string | null): Language =>
  "en";
